import React from 'react';
import styles from './GebiedsanalyseModule.module.css';
import { OrganisatiesData, VoorzieningItem } from '../../types';
import { ORGANISATIE_ICON_MAP, GemeentehuisIcon, PinIcon } from './CategoryIcons';

const CATEGORY_LABELS: Record<string, string> = {
  scholen: 'Scholen & Onderwijs',
  zorginstellingen: 'Zorginstellingen',
  sportverenigingen: 'Sportverenigingen',
  religieuze_instellingen: 'Religieuze instellingen',
  culturele_organisaties: 'Culturele organisaties',
};

const CATEGORY_ICON_LOOKUP: Record<string, React.FC<{ size?: number; color?: string }>> = {
  ...ORGANISATIE_ICON_MAP,
  religieuze_instellingen: GemeentehuisIcon,
};

interface OrganisatiesSectionProps {
  data: OrganisatiesData | null;
  onItemClick?: (lat: number, lon: number) => void;
}

export default function OrganisatiesSection({ data, onItemClick }: OrganisatiesSectionProps) {
  if (!data || data.totaal === 0) return null;

  return (
    <div className={styles.section}>
      <h3>Maatschappelijke Organisaties (binnen {data.searchRadius / 1000} km)</h3>

      <p style={{
        fontFamily: "'Open Sans', sans-serif",
        fontSize: 12,
        color: '#9DA6A8',
        margin: '0 0 12px',
        lineHeight: 1.5
      }}>
        Relevant voor participatie en stakeholderanalyse
      </p>

      <div className={styles.facilityList}>
        {data.stats.map(stat => {
          const label = CATEGORY_LABELS[stat.category] || stat.category;
          const IconComp = CATEGORY_ICON_LOOKUP[stat.category] || PinIcon;
          return (
            <div key={stat.category} className={styles.facilityItem}>
              <span>
                <span className={styles.categoryIcon}><IconComp size={14} color="#9DA6A8" /></span>{' '}
                {label}
              </span>
              <span>{stat.count}x</span>
            </div>
          );
        })}
      </div>

      {data.items.length > 0 && (
        <div style={{ marginTop: 14 }}>
          <h4 style={{
            fontFamily: "'Open Sans', sans-serif",
            fontSize: 12,
            fontWeight: 600,
            color: '#9DA6A8',
            textTransform: 'uppercase',
            margin: '0 0 6px',
            letterSpacing: '0.5px'
          }}>Organisaties in de omgeving</h4>
          <div className={styles.topSectorenList}>
            {data.items.slice(0, 10).map((item: VoorzieningItem) => {
              const IconComp = CATEGORY_ICON_LOOKUP[item.category] || PinIcon;
              return (
                <button
                  key={item.osmId}
                  className={styles.omgevingsListItem}
                  onClick={() => onItemClick?.(item.lat, item.lon)}
                >
                  <span className={styles.categoryIcon}><IconComp size={14} color="#9DA6A8" /></span>
                  <span className={styles.omgevingsListContent}>
                    <span className={styles.omgevingsListTitle}>{item.name}</span>
                    <span className={styles.omgevingsListMeta}>
                      {item.subcategory} — {item.distance} km
                    </span>
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
